module.exports = __webpack_public_path__ + "img/298.7e22e632.jpg";